import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IAuftragMessageListe } from "../types/Types";

/**
 * @author mb
 */
export const AuftragMessagesAPI = createApi({
    reducerPath: "auftragMessagesAPI",
    baseQuery: fetchBaseQuery(
        {
            baseUrl: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + "auftragmessages",
            credentials: 'include'
        }),
    tagTypes: ['auftragMessagesAPI'], // for caching
    endpoints: (builder) => ({
        getAuftragMessagesListe: builder.mutation<IAuftragMessageListe[], void>(
            {
                query: () => ({
                    url: '/auftragsliste/',
                    method: 'get',
                    credentials: 'include'
                }),
                invalidatesTags: ["auftragMessagesAPI"],
            }
        ),
        chatgelesen: builder.mutation<void, string>(
            {
                query: (uid) => ({
                    url: '/chatgelesen/' + uid,
                    method: 'post',
                    credentials: 'include'
                }),
                invalidatesTags: ["auftragMessagesAPI"],
            }
        ),
        
    })
});

export const {
    useGetAuftragMessagesListeMutation,
    useChatgelesenMutation,

} = AuftragMessagesAPI;
